import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import PageLoader from '../components/loader/LoaderText';
import { NAVIGATE_AUTH } from '../constant';
import AuthLayout from '../layout/AuthLayout';
import LogoutPage from '../pages/auth/logout';
import BlankLayout from '../layout/BlankLayout';

const Error404 = lazy(() => import('../pages/error/Error404'));

const LoginPage = lazy(() => import('../pages/auth/login'));
const ResetPasswordPage = lazy(() => import('../pages/auth/reset-password'));

const AuthRoute = () => {
    return (
        <Suspense fallback={<AuthLayout><PageLoader /></AuthLayout>}>
            <Routes>
                <Route path='*' element={<Error404 />}></Route>
                <Route path={NAVIGATE_AUTH.LOGIN} element={<AuthLayout><LoginPage /></AuthLayout>}></Route>
                <Route path={NAVIGATE_AUTH.LOGOUT} element={<BlankLayout><LogoutPage /></BlankLayout>}></Route>
                <Route path={NAVIGATE_AUTH.RESET_PASSWORD} element={<AuthLayout><ResetPasswordPage /></AuthLayout>}></Route>
            </Routes>
        </Suspense>
    )
}

export default AuthRoute;